const MCQCards = [
  {
    id: 1,
    title: "MCQ on Digital Forensics Examiner",
    description:
      "These are multiple choice questions that are designed to be a review for the exam.",
    difficulty: "Easy",
    image: require("../../assets/img/CareersInCyber/landing.jpg"),
    link: "/CareersInCyber/CareersInCyber_MCQ/Digital_Forensics_Examiner/MCQ/",
  },
  {
    id: 2,
    title: "MCQ on Incident Responder",
    description:
      "These are multiple choice questions that are designed to be a review for the exam.",
    difficulty: "Easy",
    image: require("../../assets/img/CareersInCyber/landing.jpg"),
    link: "/CareersInCyber/CareersInCyber_MCQ/Incident_Responder/MCQ",
  },
  {
    id: 3,
    title: "MCQ on Malware Analyst",
    description:
      "These are multiple choice questions that are designed to be a review for the exam.",
    difficulty: "Easy",
    image: require("../../assets/img/CareersInCyber/landing.jpg"),
    link: "/CareersInCyber/CareersInCyber_MCQ/Malware_Analyst/MCQ",
  },
  {
    id: 4,
    title: "MCQ on Penetration Tester",
    description:
      "These are multiple choice questions that are designed to be a review for the exam.",
    difficulty: "Easy",
    image: require("../../assets/img/CareersInCyber/landing.jpg"),
    link: "/CareersInCyber/CareersInCyber_MCQ/Penetration_Tester/MCQ",
  },
  {
    id: 5,
    title: "MCQ on Red Teamer",
    description:
      "These are multiple choice questions that are designed to be a review for the exam.",
    difficulty: "Easy",
    image: require("../../assets/img/CareersInCyber/landing.jpg"),
    link: "/CareersInCyber/CareersInCyber_MCQ/Red_Teamer/MCQ",
  },
  {
    id: 6,
    title: "MCQ on Security Analyst",
    description:
      "These are multiple choice questions that are designed to be a review for the exam.",
    difficulty: "Easy",
    image: require("../../assets/img/CareersInCyber/landing.jpg"),
    link: "/CareersInCyber/CareersInCyber_MCQ/Security_Analyst/MCQ",
  },
  {
    id: 7,
    title: "MCQ on Security Engineer",
    description:
      "These are multiple choice questions that are designed to be a review for the exam.",
    difficulty: "Easy",
    image: require("../../assets/img/CareersInCyber/landing.jpg"),
    link: "/CareersInCyber/CareersInCyber_MCQ/Security_Engineer/MCQ",
  },
];

export default MCQCards;
